export default {
    path: "/company/:companyId",
    name: "company",
    meta: {
        title: "团队设置",
        isDropdown: true,
        icon: "bri-company",
        custom: true
    },
    redirect: {
        name: "companyBase"
    },
    props: true,
    component: () => import("@/views/company/company.vue"),
    children: [
        {
            path: "base",
            name: "companyBase",
            meta: {
                title: "团队资料",
                icon: "bri-company-data"
            },
            props: true,
            component: () => import("@/views/company/companyBase.vue")
        },
        {
            path: "statistics",
            name: "usageStatistics",
            meta: {
                title: "用量统计",
                icon: "bri-company-statistics"
            },
            props: true,
            component: () => import("@/views/company/usageStatistics.vue")
        },
        {
            path: "member",
            name: "companyMember",
            meta: {
                title: "团队员工",
                icon: "bri-company-member"
            },
            props: true,
            component: () => import("@/views/company/companyMember.vue")
        },
        {
            path: "department",
            name: "companyDepartment",
            meta: {
                title: "团队部门",
                icon: "bri-company-department"
            },
            props: true,
            component: () => import("@/views/company/companyDepartment.vue")
        },
        {
            path: "admin",
            name: "companyAdmin",
            meta: {
                title: "团队管理员",
                icon: "bri-company-admin"
            },
            props: true,
            component: () => import("@/views/company/companyAdmin.vue")
        },
        {
            path: "apps",
            name: "companyApps",
            meta: {
                title: "团队应用",
                icon: "bri-company-apps"
            },
            props: true,
            component: () => import("@/views/company/companyApps.vue")
        },
        {
            path: "messages",
            name: "companyMessages",
            meta: {
                title: "团队公告",
                icon: "bri-company-notice"
            },
            props: true,
            component: () => import("@/views/company/companyMessages.vue")
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/company.js